
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

interface BlogPost {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  date: string;
  readTime: string;
  image: string;
  featured: boolean;
}

const categories = [
  { id: 'todos', name: 'Todos', icon: 'ri-apps-line' },
  { id: 'luz', name: 'Luz', icon: 'ri-lightbulb-line' },
  { id: 'gas', name: 'Gas', icon: 'ri-fire-line' },
  { id: 'dual', name: 'Dual', icon: 'ri-flashlight-line' },
  { id: 'empresas', name: 'Empresas', icon: 'ri-building-line' },
  { id: 'solar', name: 'Solar', icon: 'ri-sun-line' },
  { id: 'bateria', name: 'Batería Virtual', icon: 'ri-battery-charge-line' },
  { id: 'ahorro', name: 'Ahorro', icon: 'ri-money-euro-circle-line' },
  { id: 'faq', name: 'FAQ', icon: 'ri-question-line' }
];

const blogPosts: BlogPost[] = [
  {
    id: '1',
    slug: 'como-reducir-factura-luz-2025',
    title: '7 formas de reducir tu factura de luz en 2025',
    excerpt: 'Descubre las estrategias más efectivas para pagar menos en tu factura eléctrica sin renunciar a tu confort.',
    category: 'luz',
    date: '2025-01-15',
    readTime: '5 min',
    image: 'https://public.readdy.ai/ai/img_res/96b4a61d04568240063ac887bf6945ca.jpg',
    featured: true
  },
  {
    id: '2',
    slug: 'excedentes-solares-como-funcionan',
    title: 'Excedentes solares: cómo funcionan y cómo aprovecharlos',
    excerpt: 'Si tienes placas solares, necesitas saber esto para no perder dinero cada mes.',
    category: 'solar',
    date: '2025-01-12',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=residential%20solar%20panels%20on%20modern%20house%20roof%20with%20energy%20meter%20showing%20surplus%20electricity%20production%2C%20bright%20sunny%20day%20with%20clear%20blue%20sky%20and%20green%20landscape&width=800&height=500&seq=blog2&orientation=landscape',
    featured: true
  },
  {
    id: '3',
    slug: 'contrato-dual-luz-gas-ventajas',
    title: 'Contrato dual de luz y gas: ¿realmente ahorras?',
    excerpt: 'Analizamos cuándo merece la pena unificar tus contratos de luz y gas en uno solo.',
    category: 'dual',
    date: '2025-01-10',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20kitchen%20with%20gas%20stove%20and%20electric%20appliances%20showing%20dual%20energy%20contract%20concept%2C%20warm%20lighting%20and%20contemporary%20design%20with%20energy%20bills%20on%20counter&width=800&height=500&seq=blog3&orientation=landscape',
    featured: false
  },
  {
    id: '4',
    slug: 'bateria-virtual-que-es',
    title: '¿Qué es la batería virtual y por qué te interesa?',
    excerpt: 'La batería virtual te permite acumular el valor de tus excedentes solares sin instalar nada físico.',
    category: 'bateria',
    date: '2025-01-08',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=digital%20illustration%20of%20virtual%20battery%20concept%20with%20solar%20energy%20storage%20visualization%2C%20futuristic%20technology%20interface%20showing%20energy%20credits%20and%20savings%20dashboard&width=800&height=500&seq=blog4&orientation=landscape',
    featured: false
  },
  {
    id: '5',
    slug: 'reducir-costes-energia-empresa',
    title: 'Cómo reducir los costes de energía en tu empresa',
    excerpt: 'Estrategias profesionales para optimizar el gasto energético de tu negocio.',
    category: 'empresas',
    date: '2025-01-05',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20office%20building%20with%20energy%20efficient%20lighting%20and%20modern%20workspace%2C%20business%20people%20working%20with%20energy%20cost%20reduction%20charts%20on%20screens&width=800&height=500&seq=blog5&orientation=landscape',
    featured: false
  },
  {
    id: '6',
    slug: 'tarifa-gas-cual-elegir',
    title: 'Tarifas de gas: ¿cuál es la mejor para tu hogar?',
    excerpt: 'Guía completa para entender las tarifas de gas y elegir la que más te conviene.',
    category: 'gas',
    date: '2025-01-03',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20home%20heating%20system%20with%20gas%20boiler%20and%20thermostat%20control%2C%20cozy%20living%20room%20with%20warm%20atmosphere%20and%20energy%20efficiency%20concept&width=800&height=500&seq=blog6&orientation=landscape',
    featured: false
  },
  {
    id: '7',
    slug: 'errores-comunes-factura-luz',
    title: '5 errores que te hacen pagar más en tu factura de luz',
    excerpt: 'Evita estos errores comunes y empieza a ahorrar desde el próximo mes.',
    category: 'ahorro',
    date: '2025-01-01',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=person%20reviewing%20electricity%20bill%20with%20calculator%20and%20worried%20expression%2C%20home%20office%20desk%20with%20energy%20bills%20and%20documents%20showing%20high%20costs&width=800&height=500&seq=blog7&orientation=landscape',
    featured: false
  },
  {
    id: '8',
    slug: 'placas-solares-rentabilidad-2025',
    title: 'Placas solares en 2025: ¿son realmente rentables?',
    excerpt: 'Análisis real de la rentabilidad de una instalación solar en España.',
    category: 'solar',
    date: '2024-12-28',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=solar%20panel%20installation%20on%20residential%20roof%20with%20installer%20working%2C%20modern%20house%20with%20photovoltaic%20system%20and%20financial%20calculator%20showing%20ROI%20calculations&width=800&height=500&seq=blog8&orientation=landscape',
    featured: false
  },
  {
    id: '9',
    slug: 'preguntas-frecuentes-cambio-comercializadora',
    title: 'FAQ: Todo sobre cambiar de comercializadora',
    excerpt: 'Resolvemos todas tus dudas sobre el proceso de cambio de compañía eléctrica.',
    category: 'faq',
    date: '2024-12-25',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=customer%20service%20representative%20helping%20client%20with%20energy%20contract%20change%2C%20professional%20office%20setting%20with%20documents%20and%20digital%20tablet%20showing%20energy%20providers&width=800&height=500&seq=blog9&orientation=landscape',
    featured: false
  }
];

export default function BlogPage() {
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const filteredPosts = selectedCategory === 'todos' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const featuredPost = blogPosts.find(post => post.featured);
  const regularPosts = filteredPosts.filter(post => !post.featured || selectedCategory !== 'todos');

  return (
    <div className="min-h-screen bg-[#F7F9FC]">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-emerald-900 via-emerald-800 to-teal-900 text-white py-20 px-4 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="blog-grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5"/>
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#blog-grid)" />
          </svg>
        </div>

        <div className="max-w-7xl mx-auto text-center relative z-10">
          <div className="w-20 h-20 bg-[#FF8F00] rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-article-line text-white text-4xl"></i>
          </div>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">
            Blog de Ahorro Energético
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Guías, consejos y estrategias para reducir tu factura de luz y gas. Información clara y práctica para ahorrar cada mes.
          </p>
        </div>
      </section>

      {/* Categories Filter */}
      <section className="bg-white border-b border-gray-200 sticky top-0 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex gap-2 overflow-x-auto pb-2 scrollbar-hide">
            {categories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                className={`flex items-center gap-2 px-4 py-2 rounded-full font-medium whitespace-nowrap transition-all cursor-pointer ${
                  selectedCategory === cat.id
                    ? 'bg-[#FF8F00] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                <i className={`${cat.icon} text-lg`}></i>
                {cat.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Post */}
      {selectedCategory === 'todos' && featuredPost && (
        <section className="max-w-7xl mx-auto px-4 py-12">
          <div className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="relative h-80 md:h-auto">
                <img 
                  src={featuredPost.image} 
                  alt={featuredPost.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#FF8F00] text-white px-4 py-2 rounded-full text-sm font-bold">
                    ⭐ Destacado
                  </span>
                </div>
              </div>
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <div className="flex items-center gap-4 mb-4">
                  <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-semibold">
                    {categories.find(c => c.id === featuredPost.category)?.name}
                  </span>
                  <span className="text-gray-500 text-sm flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {featuredPost.readTime}
                  </span>
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-4">
                  {featuredPost.title}
                </h2>
                <p className="text-lg text-gray-600 mb-6">
                  {featuredPost.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">
                    {new Date(featuredPost.date).toLocaleDateString('es-ES', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </span>
                  <Link
                    to={`/blog/${featuredPost.slug}`}
                    className="bg-[#FF8F00] hover:bg-[#E68000] text-white px-6 py-3 rounded-full font-bold transition-all inline-flex items-center gap-2 cursor-pointer whitespace-nowrap"
                  >
                    Leer artículo
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Blog Posts Grid */}
      <section className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {regularPosts.map((post) => (
            <article 
              key={post.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all transform hover:-translate-y-1"
            >
              <div className="relative h-56">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-white/95 backdrop-blur-sm text-gray-800 px-3 py-1 rounded-full text-sm font-semibold">
                    {categories.find(c => c.id === post.category)?.name}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 mb-3 text-sm text-gray-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {new Date(post.date).toLocaleDateString('es-ES', { 
                      day: 'numeric',
                      month: 'short'
                    })}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {post.readTime}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1F2937] mb-3 line-clamp-2">
                  {post.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {post.excerpt}
                </p>
                <Link
                  to={`/blog/${post.slug}`}
                  className="text-[#0A5FFF] hover:text-[#0847B3] font-semibold inline-flex items-center gap-2 cursor-pointer"
                >
                  Leer más
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </article>
          ))}
        </div>

        {filteredPosts.length === 0 && (
          <div className="text-center py-20">
            <i className="ri-file-search-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-xl text-gray-500">
              No hay artículos en esta categoría todavía
            </p>
          </div>
        )}
      </section>

      {/* CTA Section */}
      <section className="max-w-7xl mx-auto px-4 py-16">
        <div className="bg-gradient-to-br from-[#FF8F00] to-[#FF6F00] rounded-3xl p-12 text-center text-white relative overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <div className="absolute inset-0" style={{
              backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
              backgroundSize: '40px 40px'
            }}></div>
          </div>
          <div className="relative z-10">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              ¿Quieres empezar a ahorrar hoy?
            </h2>
            <p className="text-xl mb-8 text-white/90">
              Sube tu factura y descubre cuánto puedes reducir tu gasto energético
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/subir-factura"
                className="bg-white text-[#FF8F00] hover:bg-gray-100 px-8 py-4 rounded-full font-bold text-lg transition-all inline-flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
              >
                📊 Subir mi factura
              </Link>
              <a
                href="https://wa.me/34696237625?text=Hola,%20quiero%20información%20sobre%20cómo%20ahorrar%20en%20mi%20factura"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#25D366] hover:bg-[#20BA5A] text-white px-8 py-4 rounded-full font-bold text-lg transition-all inline-flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line text-xl"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* WhatsApp Sticky Button */}
      <a
        href="https://wa.me/34696237625?text=Hola,%20tengo%20una%20consulta%20sobre%20el%20blog"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all z-50 cursor-pointer"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>
    </div>
  );
}
